export default __webpack_public_path__ + "static/media/vid2.d6d701e1.mp4";